import type { ReactNode } from 'react';
import clsx from 'clsx';

export interface DerivedStatProps {
  label: string;
  value: ReactNode;
  /** Render the value at larger size (e.g. TIV dollar amount). */
  serif?: boolean;
  className?: string;
}

/**
 * Live-derived number readout (TIV, project days, pro-rata). Mono eyebrow
 * label with a `>` prefix, Inter-display tabular value.
 */
export function DerivedStat({ label, value, serif, className }: DerivedStatProps) {
  return (
    <div
      className={clsx(
        'flex flex-col gap-1 border-t border-hairline pt-4',
        className,
      )}
      aria-live="polite"
    >
      <span className="font-mono text-[10px] uppercase tracking-[0.125em] text-ink-subtle">
        &gt; {label}
      </span>
      <span
        className={clsx(
          'font-display font-tnum text-ink',
          serif ? 'font-light text-[2rem] leading-none' : 'font-medium text-[1.125rem] leading-snug',
        )}
      >
        {value}
      </span>
    </div>
  );
}
